<div class="library container-component container-fluid">

    <div class="library-current">
        <current-selection-component
                *ngIf="currentSelection || nextSelection"
                (selectRequest)="selectionClick($event)"
                [selection]="currentSelection"
                [nextSelection]="nextSelection">
        </current-selection-component>
    </div>
    <div class="assigned-library-header">
        <h5 *ngIf="!categorySelected$.value" class="library-title">Assigned Library</h5>
        <ng-container *ngIf="!!categorySelected$.value">
            <div (click)="categorySelected$.next(null)" class="back-btn-container">
                <button class="btn btn-info"><i class="bi bi-chevron-left"></i></button>
                <span class="text-white">Back</span>
            </div>
            <div class="category-selected-header">
                <div class="category-item-selection">
                    <img [style]="'content: url('+getIconUrl(categorySelected$.value.icon)+');'"   class="category-icon"/>
                </div>
                <span>{{categorySelected$.value.label}}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="!isUserLocked()">
            <div *ngIf="browseBy === 0" class="search-bar">
                <i class="bi bi-search left-slot"></i>
                <input [ngModel]="searchTerm$ | async" [disabled]="isSearchAndBrowseByDisabled()" (ngModelChange)="searchTerm$.next($event)" type="text" class="form-control" placeholder="Search by Title, Topic or Keyword">
                <i *ngIf="(searchTerm$ | async).length > 0" (click)="searchTerm$.next('')" class="bi bi-x-circle-fill right-slot"></i>
            </div>
            <div *ngIf="!categorySelected$.value" class="browse-by-container">
                <span>Browse by</span>
                <ng-select (change)="categorySelected$.next(null)" [(ngModel)]="browseBy" [readonly]="isSearchAndBrowseByDisabled()" [clearable]="false">
                    <ng-option [value]="0"><i class="bi bi-book"></i> Books</ng-option>
                    <ng-option [value]="1"><i class="bi bi-tag"></i> Categories</ng-option>
                </ng-select>
            </div>
        </ng-container>
    </div>
    <div *ngIf="browseBy === 0 || !!categorySelected$.value" class="row library-backdrop"
         [ngClass]="{'pull-down-library': currentSelection || nextSelection, 'has-next-selection': nextSelection}">
        <div *ngFor="let selection of filteredSelections$ | async; first as isFirst" class="col-lg-2 col-sm-3 mb-2 mt-2">
            <a class="book-cover mx-auto"
               (click)="selectionClick(selection)"
               [ngClass]="getCompleted(selection)"
               [ngStyle]="{'background-image': 'url(' +  getLibraryImage(selection.storyDescription?.coverImage || '')  + ')' }">
                <div *ngIf="getSeriesTitle(selection)" class="small-title">{{ getSeriesTitle(selection) }}</div>
                <div *ngIf="getBadges(selection)" class="badge_overlay" [ngClass]="getBadges(selection)"></div>
                <div *ngIf="currentSelection?.isCurrent && nextSelection && isFirst" class="next-selection-heading">
                    Next Selection
                </div>
            </a>
        </div>
    </div>
    <div *ngIf="browseBy === 1 && !categorySelected$.value" class="row">
        <div class="category-selection-container">
            <div *ngFor="let category of categories" class="category-item">
                <div (click)="categorySelected$.next(category)" class="category-item-selection">
                    <h4 class="category-num badge rounded-pill">
                        {{category.numOfItems}}
                    </h4>
                    <div [style]="'content: url('+getIconUrl(category.icon)+');'" class="category-icon"></div>
                </div>
                <span class="category-label">{{category.label}}</span>
            </div>
        </div>
    </div>
</div>
